import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'app/core/config/application-config.service';
import RelatorioUtils from 'app/shared/sefaz/relatorio-util';

@Injectable({ providedIn: 'root' })
export class RelatoriosService {

    resourceUrl = this.applicationConfigService.getEndpointFor('/sfz-obrigacoes-acessorias-api/api/relatorios/dac');

    constructor(
      protected http: HttpClient,
      protected applicationConfigService: ApplicationConfigService
    ) {}

    public downloadRelatorio(params: any, uri: string): Observable<any> {
      return this.http.get(`${this.resourceUrl + uri}`, {
        params,
        ...RelatorioUtils.criarParametrosRelatorios()
      });
    }

}
